<template>
  <div class="campaign">
    <template v-if="!isLoading && !loadingData">
      <div class="campaign__header">
        <div class="campaign__header__back" @click.stop="goToDetail()">
          <span class="campaign__header__back__icon"><i class="adx-ic_arrow_left"></i></span>
          <span class="campaign__header__back__all subhead">Campaign Detail</span>
        </div>
        <div>
          <div class="campaign__header__title">
            <h1 class="medium-title">{{ campaign.title }}</h1>
          </div>
          <div class="campaign__header__sub-title">
            <h1 class="xsmall-title">Content Campaign</h1>
          </div>
          <div class="campaign__header__period">
            <label-status class="status" :progress="displayStatus(campaign.status)"/>
            <span class="subhead period-text">Campaign Period</span>
            <span class="subhead">{{ displayPeriod(campaign.start, campaign.end) }}</span>
          </div>
          <!-- <div class="campaign__header__change-content">
            <div class="status">
              <span class="subhead status-text">Status</span>
              <span class="subhead">{{ displayStatus(campaign.status) }}</span>
            </div>
          </div> -->
        </div>
      </div>
      <div class="campaign__body">
        <div class="content">
          <div>
            <table>
              <thead class="none">
                <tr>
                  <td class="header1 p">CONTENT</td>
                  <td class="header2 p">CHANGE REQUEST STATUS</td>
                  <td class="p" :class="[!isObserver ? 'header3' : 'header-nobutton']">ORIENTATION</td>
                  <td class="p" :class="[!isObserver ? 'header4' : 'header-nobutton' ]">TYPE</td>
                  <td></td>
                </tr>
              </thead>
              <tbody v-if="!isLoading && !isEmpty">
                <tr v-for="(item, index) in items" :key="index" class="content">
                  <td class="places">
                    <div class="item">
                      <div class="thumbnail">
                        <img v-if="item.thumb" :src="item.thumb" alt="" @click="imagePreview(item)">
                        <img v-else :src="`/img/notfound/img-placeholder_square.jpg`" alt="">
                      </div>
                      <div class="stack">
                        <span class="stack__top">{{ item.title }}</span>
                        <span class="stack__bottom">{{item.campaign_name}}</span>
                      </div>
                    </div>
                  </td>
                  <td v-if ="item.temp_content_status  == 'Pending' " class="status__pending">Pending</td>
                  <td v-else-if ="item.temp_content_status  == 'Approved' " class="status__approve">Approved</td>
                  <td v-else-if ="item.temp_content_status  == 'Rejected' " class="status__reject">Rejected</td>
                  <td v-else class="status">Not Applicable</td>
                  <td v-if="item.rotation == 0" class="orientation">Landscape</td>
                  <td v-if="item.rotation == 90" class="orientation">Portrait</td>
                  <td v-if="item.width && item.height" class="orientation">{{item.type}} {{item.height}} x {{item.width}} px</td>
                  <td class="change-content">
                    <button v-if="!isObserver" class="btn-small secondary" :disabled="['expired', 'cancel', 'disapproved'].includes(campaign.status)" 
                    @click.stop="changeContent(item, item.rotation == 0? 'landscape' : 'portrait')">Change Content</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- footer -->
            <div class="range" v-if="!isLoading && !isEmpty">{{getDataRange}} of {{count}} Items</div>
            <!-- Loading State -->
            <div class="loadingState"><adx-loading v-if="isLoading" slot="loading" /></div>
            <!-- Empty State -->
            <div class="emptyState"><adx-empty-selection v-if="isEmpty && !loading" /></div>
          </div>
        </div>
      </div>
    </template>
      <div v-else class="campaign__loading">
        <adx-loading />
      </div>
      <!-- modal library -->
      <modal
        v-if="isShowModal"
        type="large"
        title="Change Media File"
        @modal-close="closeMediaModal">
          <div slot="content" class="media_editor">
            <div class="media_editor__menu">
              <span :class="['medialib', modalMediaTab == 'media' ? 'active' : '']" @click.stop="changeMediaTab('media')" class="subhead">Media Library</span>
              <span :class="['localfile', modalMediaTab == 'localfile' ? 'active' : '']" @click.stop="changeMediaTab('localfile')" class="subhead">Upload File</span>
            </div>
            <div class="media_editor__content">
              <adx-media v-if="modalMediaTab == 'media'" :orientation="orientationOnModal" :is-modal="true" @selected="sendEmail" />
              <adx-upload v-if="modalMediaTab == 'localfile'" @done="changeMediaTab('media')" :orientation="orientationOnModal" />
            </div>
          </div>
      </modal>
      <!-- modal preview image -->
      <adx-modal
        v-if="isImagePreview"
        type="full"
        @modal-close="closeModalPreview">
        <div slot="content" class="preview">
          <div :class="['preview__content']">
              <div class="item">
                <div class="preview__content__slide">
                  <div v-if="content.imageType == 'Image'" :class="['img-preview', content.imageOrientation]" :style="{backgroundImage: 'url(' + content.imageUrl + ')'}"></div>
                  <div v-else :class="['videos', content.imageOrientation]">
                    <video controls 
                          preload="auto"
                          :poster="content.thumbnail">
                      <source :src="content.imageUrl" type="video/mp4">
                      Your browser does not support HTML5 video.
                    </video>
                  </div>
                </div>
                <div class="preview__footer">
                  <div class="filename-section">
                    <span class="section-key">File Name</span>
                    <span class="section-value">{{content.imageTitle}}</span>
                  </div>
                  <div class="filesize-section">
                    <span class="section-key">Orientation</span>
                    <span class="section-value">{{content.imageOrientation}}</span>
                </div>
                </div>
              </div>
          </div>
        </div>
      </adx-modal>
  </div>
</template>

<script>
import Empty from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'
import Modal from '@/components/Modal'
import Pagination from '@/components/Pagination'
import Upload from '@/views/Upload'
import LabelStatus from '@/components/StatusLabel'
import MediaLibrary from '@/views/Media'
import table from '@/components/Table'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import lib from '@/lib/util'
import { helpers } from '@/lib/validation/'
import { mapGetters } from 'vuex';

export default {
  name: 'adx-dashboard-campaign-detail',
  components: {
    'adx-empty': Empty,
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'adx-upload': Upload,
    'adx-media': MediaLibrary,
    'adx-modal': Modal,
    'label-status': LabelStatus,
    'adx-table': table,
     Modal
  },
  props: {

  },
  data() {
    return {
      selectedPage: 1,
      // maxPage: 1,
      campaignId: null,
      orientationOnModal: null,
      display: 'grid',
      modalMediaTab: 'media',
      type: 'medium',
      items:[],
      isLoading: false,
      loadingData: false,
      modalUpload: false,
      isEmpty: false,
      isShowModal: false,
      isImagePreview : false,
      count: 0,
      isObserver: false,
      query_route: null,
      campaign: {
        title: '',
        start: '',
        end: '',
        status: '',
      },
      content: {
        imageId : null,
        imageTitle: null,
        imageUrl: null,
        imageOrientation: null,
        imageType: null,
        thumbnail : null
      },
      newContent: {
        imageId : null,
        imageTitle: null,
        imageUrl: null,
        imageOrientation: null,
        imageType: null,
        thumbnail : null
      },
      data: {
        checkbox: false,
        head: [
          {
            title: "ID",
            type: "text",
            display: "display:none;"
          },
          {
            title: "CONTENT",
            type: "text"
          },
          {
            title: "CHANGE REQUEST STATUS",
            type: "text"
          },
          {
            title: "ORIENTATION",
            type: "text"
          },
          {
            title: "TYPE",
            type: "text"
          },
          {
            title: "",
            type: "button"
          },
        ],
        body : []
      },
    }
  },
  computed: {
    ...mapGetters({
        user: 'account',
        token: 'token'
    }),
    getDataRange: function(){
      return (this.count%15===0 || this.selectedPage===1) && this.count>15?this.selectedPage*15:(this.selectedPage*15-15)+(this.count%15)
    },
  },
  watch: {
    
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.campaignId = this.$route.params.id
    this.query_route = this.$route.query
    this.isLoading = true
    // this.getCampaignDetail()
    this.getCampaignContent()
    this.isLoading = false
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    selectPage(page) {
      this.selectedPage = page
      // this.getCampaignDetail()
      this.getCampaignContent()
    },
    closeMediaModal() {
      this.isShowModal = false
    },
    changeMediaTab(selected) {
      this.modalMediaTab = selected
    },
    closeModalPreview(){
      this.isImagePreview = false
    },
    displayStatus(status) {
      return lib.displayCampaignStatus(status)
    },
    goToDetail() {
      this.$router.push({ name: 'digitalscrdetail', query: this.query_route })
    },
    displayPeriod(start, end) {
      return `${lib.formatShortDate(start)} - ${lib.formatShortDate(end)}`
    },
    changeContent(item, orientation) {
      this.content.campaign_id = item.campaign_id
      this.content.campaign_name = item.campaign_name
      this.content.imageId = item.id
      this.content.imageType = item.type
      this.content.imageTitle = item.title 
      this.content.thumbnail = item.thumb
      this.content.imageUrl = item.preview_url
      this.content.imageOrientation = item.rotation == 0 ? 'landscape' : 'portrait'
      this.orientationOnModal = orientation
      this.isShowModal = true
    },
    imagePreview(item){
      this.content.campaign_id = item.campaign_id
      this.content.campaign_name = item.campaign_name
      this.content.imageId = item.id
      this.content.imageType = item.type
      this.content.imageTitle = item.title 
      this.content.imageUrl = item.preview_url
      this.content.thumbnail = item.thumb
      this.content.imageOrientation = item.rotation == 0 ? 'landscape' : 'portrait'
      this.isImagePreview = true
    },
    // getCampaignDetail() {
    //   (async () => {
    //     this.loadingData = true
    //     let param = {}
    //     param.page = this.selectedPage
    //     let response = await api.get(apiV2.campaignDetail(this.campaignId), {needToken: true, params: param})
    //     if (response.status == 200) {
    //       let data = response.data
    //       this.loadingData = false
    //     } 
    //   })();
    // },
    getCampaignContent() {
      (async () => {
        this.loadingData = true
        let response = await api.get(apiV2.dashboardStaticDSContent(this.campaignId), {needToken: true})
        if (response.status == 200) {
          let data = response.data.campaign
          // this.items = data.contents
          this.campaign = response.data
          this.campaign.status = response.data.status.toLowerCase()
          this.mappingData(data)
          this.loadingData = false
        } 
      })();
    },
    async mappingData(data){
      let items = []
      let result = data

      await result.map(async campaign => {
        let content = campaign.contents
        // let campaign = {
        //   campaign_id: campaign.campaign_id,
        //   campaign_name: campaign.campaign_name
        // }
        await content.map(res => {
          items.push({
            ...res,
            campaign_id: campaign.campaign_id,
            campaign_name: campaign.campaign_name})
        })
         this.isObserver = campaign.is_observer
      })
      this.items = items
      this.count = this.items.length;
      this.isLoading = false
    },
    sendEmail(item) {
      this.newContent.imageId = item.id
      this.newContent.thumbnail = item.thumb
      this.newContent.imageTitle = item.title 
      this.newContent.imageUrl = item.url
      this.newContent.imageType = item.type
      this.newContent.imageOrientation = item.rotation == 0 ? 'landscape' : 'portrait';

      (async () => {
        let data = {
          "campaign_id": this.content.campaign_id,
          "campaign_name": this.content.campaign_name,
          "content": {
            "id" : this.content.imageId,
            "name" : this.content.imageTitle,
            "type" : this.content.imageType,
            "primary_content" : this.content.imageUrl,
            "secondary_content" : this.content.thumbnail,
            "rotation" : this.content.imageOrientation
          },
          "new_content": {
            "id" : this.newContent.imageId,
            "name" : this.newContent.imageTitle,
            "type" : this.newContent.imageType,
            "primary_content" : this.newContent.imageUrl,
            "secondary_content" : this.newContent.thumbnail,
            "rotation" : this.newContent.imageOrientation
          }
        }
        const response = await api.post(apiV2.sendEmailContent(this.content.campaign_id), data, { needToken: true })
        if (response.status == 200) {
            this.getCampaignContent()
            this.$notify({
              group: 'saved',
              title: `Success`,
              text: 'Your request has been sent!',
              type: 'success'
              });
              this.getCampaignContent()
        } else{
          this.$notify({
            group: 'saved',
            title: 'Error!!',
            text: 'Your request failed',
            type: 'danger',
              });
        }
      })();
      this.isShowModal = false
    },
    displayStatus(status) {
      return lib.displayLabelStatus(status)
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
